import { Card, SkeletonLoader } from '@payaca/ambrosia';
import { FC } from 'react';

export interface DashboardSectionSkeletonProps {
  /** Variant of skeleton to display */
  variant: 'summary' | 'stats-card' | 'donut';
}

const DashboardSectionSkeleton: FC<DashboardSectionSkeletonProps> = ({
  variant,
}) => {
  if (variant === 'summary') {
    return (
      <div className="space-y-3">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <SkeletonLoader className="h-7 w-32 rounded" />
          <SkeletonLoader className="h-5 w-40 rounded" />
        </div>
        <div className="grid grid-cols-1 gap-4 @screen-sm:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <SkeletonLoader
              key={i}
              className="h-32 rounded-xl border border-gray-200"
            />
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'donut') {
    return (
      <Card className="h-full">
        <Card.Body className="p-4">
          <SkeletonLoader className="mb-4 h-6 w-32 rounded" />
          <div className="flex flex-col items-center gap-4 @screen-sm:flex-row @screen-sm:items-start">
            <SkeletonLoader className="size-40 shrink-0 rounded-full" />
            <div className="w-full flex-1 space-y-3">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-center justify-between py-2">
                  <div className="flex items-center gap-2">
                    <SkeletonLoader className="size-3 rounded-full" />
                    <SkeletonLoader className="h-4 w-20 rounded" />
                  </div>
                  <div className="text-right">
                    <SkeletonLoader className="mb-1 h-4 w-16 rounded" />
                    <SkeletonLoader className="h-3 w-12 rounded" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }

  // stats-card variant
  return (
    <Card>
      <Card.Body>
        <SkeletonLoader className="h-32 w-full rounded-lg" />
      </Card.Body>
    </Card>
  );
};

export default DashboardSectionSkeleton;
